import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaHome } from 'react-icons/fa';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <header className="fixed top-0 w-full z-50">
            {/* Ticker Bar */}
            <div className="bg-[#1a2b4d]/90 text-white text-[10px] py-2 flex items-center w-full overflow-hidden">
                {/* Marquee Wrapper */}
                <div className="flex-1 overflow-hidden relative">
                    <div className="whitespace-nowrap animate-marquee font-bold tracking-wider inline-block text-2xl md:text-3xl">
                        Car Rental • Real Estate • Business Setup • Relocation Services • Cab Services • Packers & Movers
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                </div>
            </div>

            {/* Main Nav */}
            <nav className="bg-white/30 backdrop-blur-md py-4 px-6 md:px-8 flex items-center justify-between border-b border-white/20">
                <Link to="/" className="flex items-center">
                    <img
                        src="/logo.png"
                        alt="Logo"
                        className="h-20 md:h-24 w-auto object-contain transition-all duration-300 hover:scale-105"
                    />
                </Link>

                {/* Desktop Links */}
                <div className="hidden lg:flex items-center space-x-10 text-[16px] font-extrabold text-[#1a2b4d]">
                    <Link
                        to="/"
                        className="group flex items-center justify-center w-12 h-12 rounded-full bg-white/10 hover:bg-[#3512e4] text-white transition-all duration-300 border border-white/20 hover:border-transparent hover:shadow-[0_0_15px_rgba(241,90,36,0.5)]"
                    >
                        <FaHome className="text-xl group-hover:scale-110 transition-transform duration-300 text-[#1a2b4d] group-hover:text-white" />
                    </Link>
                    <Link to="/about" className="hover:text-[#520de6] uppercase">About Us</Link>
                    <Link to="/services" className="hover:text-[#1e25f0] uppercase">Services</Link>
                    <Link to="/faq" className="hover:text-[#3120e3] uppercase">FAQ</Link>
                    <Link to="/contact" className="hover:text-[#411de0] uppercase">Contact</Link>
                </div>

                {/* Right Tools & Mobile Toggle Button */}
                <div className="flex items-center space-x-4">
                    {/* Enquiry Button (Desktop) */}
                    <Link
                        to="/enquiry"
                        className="hidden md:flex items-center bg-[#0e1f40] text-white px-8 py-3 rounded-sm text-sm font-black hover:bg-[#f15a24] uppercase transition tracking-wider shadow-lg"
                    >
                        Enquiry Now
                    </Link>

                    {/* Mobile Menu Hamburger Button (Ye gayab ho gaya tha, ab wapas aa gaya hai) */}
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="lg:hidden text-[#1a2b4d] text-2xl focus:outline-none bg-white/50 p-2 rounded-lg"
                    >
                        {isOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>
            </nav>

            {/* Mobile Menu Overlay */}
            {isOpen && (
                <div className="lg:hidden bg-white/95 backdrop-blur-lg w-full absolute top-full left-0 p-6 flex flex-col space-y-4 shadow-2xl text-[#1a2b4d] font-bold border-b border-gray-200">
                    <Link to="/" onClick={() => setIsOpen(false)} className="hover:text-[#f15a24]">Home</Link>
                    <Link to="/about" onClick={() => setIsOpen(false)} className="hover:text-[#f15a24]">About Us</Link>
                    <Link to="/services" onClick={() => setIsOpen(false)} className="hover:text-[#f15a24]">Services</Link>
                    <Link to="/faq" onClick={() => setIsOpen(false)} className="hover:text-[#f15a24]">FAQ</Link>
                    <Link to="/contact" onClick={() => setIsOpen(false)} className="hover:text-[#f15a24]">Contact Us</Link>
                    <Link to="/enquiry" onClick={() => setIsOpen(false)} className="text-[#f15a24] pt-2 border-t">Enquiry Now</Link>
                </div>
            )}
        </header>
    );
};

export default Navbar;